import styled from "styled-components";
//let { innerHeight, innerWidth } = window

// const ksh42 = require("../../static/image/ksh42.png");

export const Container = styled.div`
    width:100%;
    .container{
        width:100%;
        height:100%;
      
      .title{
        color: white;
        background-color: #36BEF1;
        line-height: 30px;
        width: 25vw;
        border-radius: 12px;
        text-align: center;
        margin: 8px 8px;
        font-size:small;
        
      }
      .desc{
        color: grey;
        margin: 8px 8px;
        font-size:small;
        text-indent: 32px;
        line-height: 20px;
      }
      .voteBtn{
        width: 80%;
        margin: 24px auto;
        text-align: center;
      }
      .voteBtnText{
        width: 80%;
        margin: 24px auto;
        text-align: center;
        color: grey;
      }
     
    }

`
